import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import FabricAttributeTooltip from './FabricAttributeTooltip';
import cleaningCodeDescriptions from './cleaning-code-desc.json';
import FabricAdditionalAttributesTag from './FabricAdditionalAttributesTag';
const FabricAdditionalAttributes = t0 => {
  const $ = _c(24);
  const {
    selectedItemGroupMaterial: t1,
    selectedItemGroupCleaningCode: t2,
    isPetAndKidFriendly: t3,
    isSustainable: t4,
    selectedItemTier: t5,
    showCleaningToolTip: t6,
    isPantoneFabric: t7
  } = t0;
  const selectedItemGroupMaterial = t1 === undefined ? "" : t1;
  const selectedItemGroupCleaningCode = t2 === undefined ? "" : t2;
  const isPetAndKidFriendly = t3 === undefined ? false : t3;
  const isSustainable = t4 === undefined ? false : t4;
  const selectedItemTier = t5 === undefined ? "" : t5;
  const showCleaningToolTip = t6 === undefined ? true : t6;
  const isPantoneFabric = t7 === undefined ? false : t7;
  const cleaningCodeRef = useRef(null);
  let t8;
  try {
    let t9;
    if ($[0] !== selectedItemGroupMaterial) {
      t9 = JSON.parse(selectedItemGroupMaterial);
      $[0] = selectedItemGroupMaterial;
      $[1] = t9;
    } else {
      t9 = $[1];
    }
    t8 = t9;
  } catch {
    t8 = selectedItemGroupMaterial;
  }
  const materialGroupAttributes = t8;
  let t9;
  if ($[2] !== materialGroupAttributes) {
    t9 = Array.isArray(materialGroupAttributes) ? materialGroupAttributes : [materialGroupAttributes];
    $[2] = materialGroupAttributes;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const materialGroupAttributesArray = t9;
  let t10;
  if ($[4] !== isPetAndKidFriendly) {
    t10 = isPetAndKidFriendly ? <FabricAdditionalAttributesTag>Pet-Friendly</FabricAdditionalAttributesTag> : null;
    $[4] = isPetAndKidFriendly;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  let t11;
  if ($[6] !== isSustainable) {
    t11 = isSustainable ? <FabricAdditionalAttributesTag>Sustainable</FabricAdditionalAttributesTag> : null;
    $[6] = isSustainable;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== isPantoneFabric) {
    t12 = !!isPantoneFabric && <FabricAdditionalAttributesTag>Pantone</FabricAdditionalAttributesTag>;
    $[8] = isPantoneFabric;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  if ($[10] !== materialGroupAttributesArray) {
    t13 = materialGroupAttributesArray.filter(_temp).map(_temp2);
    $[10] = materialGroupAttributesArray;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  let t14;
  if ($[12] !== selectedItemTier) {
    t14 = selectedItemTier ? <FabricAdditionalAttributesTag>{`Tier ${selectedItemTier}  `}</FabricAdditionalAttributesTag> : null;
    $[12] = selectedItemTier;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== selectedItemGroupCleaningCode || $[15] !== showCleaningToolTip) {
    t15 = selectedItemGroupCleaningCode && cleaningCodeDescriptions[selectedItemGroupCleaningCode] ? <FabricAdditionalAttributesTag isCleaningCode={true} ref={cleaningCodeRef}>{`Cleaning Code ${selectedItemGroupCleaningCode}`}{showCleaningToolTip ? <span className="mt-0 mx-0"><FabricAttributeTooltip title={cleaningCodeDescriptions[selectedItemGroupCleaningCode].title} description={cleaningCodeDescriptions[selectedItemGroupCleaningCode].description} parentRef={cleaningCodeRef} /></span> : null}</FabricAdditionalAttributesTag> : null;
    $[14] = selectedItemGroupCleaningCode;
    $[15] = showCleaningToolTip;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t12 || $[20] !== t13 || $[21] !== t14 || $[22] !== t15) {
    t16 = <div className="w-full flex flex-row items-stretch flex-wrap">{t10}{t11}{t12}{t13}{t14}{t15}</div>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  return t16;
};
FabricAdditionalAttributes.propTypes = {
  selectedItemGroupMaterial: PropTypes.string,
  selectedItemGroupCleaningCode: PropTypes.string,
  isPetAndKidFriendly: PropTypes.bool,
  isSustainable: PropTypes.bool,
  selectedItemTier: PropTypes.string,
  showCleaningToolTip: PropTypes.bool,
  isPantoneFabric: PropTypes.bool
};
export default FabricAdditionalAttributes;
function _temp(attribute) {
  return attribute;
}
function _temp2(attribute_0) {
  return <FabricAdditionalAttributesTag key={attribute_0}>{attribute_0 === "greenguard" ? "GREENGUARD gold" : attribute_0}</FabricAdditionalAttributesTag>;
}